module.exports = require("npm:@angular/platform-browser-dynamic@2.0.0-rc.1/index.js");